export const CHANNELS_GET = "CHANNELS_GET";
export const CHANNELS_SET = "CHANNELS_SET";
export const CHANNELS_GET_SUCCESS = "CHANNELS_GET_SUCCESS";
export const CHANNELS_RESET = "CHANNELS_RESET";
